export var ButtonTypes = {
    default: 'default',
    primary: 'primary',
    danger: 'danger',
};
